'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var graphql = require('./graphql.js');

var OrderTrackingContext = /*#__PURE__*/React.createContext(null);
var OrderTrackingProvider = function OrderTrackingProvider(_ref) {
  var value = _ref.value,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(OrderTrackingContext.Provider, {
    value: value
  }, children);
};
var index = (function () {
  var orderTrackingData = React.useContext(OrderTrackingContext);
  var getCurrentShipment = React.useCallback(function () {
    var _ref2 = (orderTrackingData === null || orderTrackingData === void 0 ? void 0 : orderTrackingData.orders[0]) || {},
      mainShipmentId = _ref2.mainShipmentId,
      shipments = _ref2.shipments;
    if (!mainShipmentId || !shipments) return null;
    var shipment = shipments.find(function (_ref3) {
      var shipmentId = _ref3.shipmentId;
      return shipmentId === mainShipmentId;
    });
    return shipment || null;
  }, [orderTrackingData]);
  return {
    orderTrackingData: orderTrackingData,
    getCurrentShipment: getCurrentShipment
  };
});

exports.orderTrackingQuery = graphql.default;
exports.OrderTrackingContext = OrderTrackingContext;
exports.OrderTrackingProvider = OrderTrackingProvider;
exports.default = index;
